import AthleteCardContainer from "rivals/components/shared/AthleteCard/container";
import type {
  PersonIdParams,
  ProspectIdParams
} from "rivals/shared/interfaces/Athlete";
import { AthleteViews } from "rivals/shared/interfaces/Athlete";
import { CareerType } from "rivals/shared/interfaces/Career";
import { parseSlug } from "rivals/shared/utils/strings";
import styles from "./AthleteBlock.module.scss";
import type { Props } from "./types";

export default function AthleteBlock({
  athleteSlug,
  id,
  type
}: Props): React.JSX.Element | null {
  let view;
  let args: PersonIdParams | ProspectIdParams | undefined;

  /**
   * Unfortunately we have to handle the id type dynamically because
   * of how the publishing UI and Sir Trevor blocks work
   */
  if (type === CareerType.COLLEGE_PLAYER && athleteSlug) {
    args = {
      personId: parseSlug(athleteSlug),
      type: "personId"
    };
    view = AthleteViews.COLLEGE_PLAYER_VIEW;
  } else if (type === CareerType.PROSPECT) {
    args = {
      id: id,
      type: "id"
    };
    view = AthleteViews.PROSPECT_VIEW;
  }

  if (!args) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <AthleteCardContainer args={args} view={view} />
      </div>
    </div>
  );
}
